module.exports = __webpack_public_path__ + "img/banner_dialog.11f4fa3d.png";